import axios from '@/utils/axios'
// import qs from 'qs';
// 设置默认请求头（可以在应用初始化时设置一次）
axios.defaults.headers.post['Content-Type'] = 'application/json';


/**
 * 用户操作接口
 */
export default {
  /**
   * 登录接口
   * @param {*} data 
   * @returns 
   *   true {
          "code": 0,
          "msg": "success",
          "data": {
            "username": "",
            "token": "",
            "expireTime": ""
          }
        }
      false {
        "code": 10004,
        "msg": "账号或密码错误",
        "data": null
      }
   */
    goLogin: async (data) => {
      try {
        axios.defaults.headers.post['Content-Type'] = 'application/json';
        const response = await axios.post(`${process.env.VUE_APP_BASE_API}/spectral-api/api/login`,
          data,
          {}
        );
        return response.data;
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * 注册接口
     * @param {*} data 
     * @returns 
     */
    goRegister: async (data) => {
      try {
        axios.defaults.headers.post['Content-Type'] = 'application/json';
        const response = await axios.post(`${process.env.VUE_APP_BASE_API}/spectral-api/api/register`,
          data,
          {}
        );
        return response.data;
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * 获取注册验证码
     * @param {*} data 
     * @returns 
     */
    getRegisterCode: async (data) => {
      try {
        axios.defaults.headers.post['Content-Type'] = 'application/json';
        const response = await axios.post(`${process.env.VUE_APP_BASE_API}/spectral-api/api/send`,
          data,
          {}
        );
        return response.data;
      } catch (error) {
        console.log(error)
      }
    },
    /** 
     * 获取用户信息
    */
    getUserInfo: async () => {
      try {
        axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';
        const response = await axios.get(`${process.env.VUE_APP_BASE_API}/spectral-api/api/info`,
          {
            headers: {
              token: sessionStorage.getItem('token')
            }
          }
        );
        return response.data;
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * 修改人员信息
     * @param {*} data 
     * @returns 
     */
    updateUserInfo: async (data) => {
      try {
        axios.defaults.headers.post['Content-Type'] = 'application/json';
        const response = await axios.post(`${process.env.VUE_APP_BASE_API}/spectral-api/api/updateInfo`,
          data,
          {
            headers: {
              token: sessionStorage.getItem('token')
            }
          }
        );
        return response.data;
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * 获取验证码 (登录)
     * @param {*} data 
     * @returns 
     */
    getLoginCaptcha: async (data) => {
      try {
        axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
        const response = await axios.get(`${process.env.VUE_APP_BASE_API}/spectral-api/api/captcha?uuid=${data}`,
          {
            responseType: 'blob'
          }
        );
        return response.data;
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * 修改密码
     * @param {*} data 
     * @returns 
     */
    updateOldPassword: async (data) => {
      try {
        axios.defaults.headers.post['Content-Type'] = 'application/json';
        const response = await axios.post(`${process.env.VUE_APP_BASE_API}/spectral-api/api/updatePwd`,
          data,
          {
            headers: {
              token: sessionStorage.getItem('token')
            }
          }
        );
        return response.data;
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * 退出登录
     */
    logout: async () => {
      try {
        axios.defaults.headers.post['Content-Type'] = 'application/json';
        const response = await axios.post(`${process.env.VUE_APP_BASE_API}/spectral-api/api/logout`,
          '',
          {
            headers: {
              token: sessionStorage.getItem('token')
            }
          }
        );
        return response.data;
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * 获取重置密码验证码
     * @param {*} data 
     * @returns 
     */
    getRegisterCodeToRestPassword: async (data) => {
      try {
        axios.defaults.headers.post['Content-Type'] = 'application/json';
        const response = await axios.post(`${process.env.VUE_APP_BASE_API}/spectral-api/api/codeForget`,
          data,
          {}
        );
        return response.data;
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * 忘记密码的修改密码
     * @param {*} data 
     * @returns 
     */
    doRestPassword: async (data) => {
      try {
        axios.defaults.headers.post['Content-Type'] = 'application/json';
        const response = await axios.post(`${process.env.VUE_APP_BASE_API}/spectral-api/api/forgetPwd`,
          data,
          {}
        );
        return response.data;
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * 提交用户反馈
     * @param {*} data 
     * @returns 
     */
    doUserFeedback: async (data) => {
      try {
        axios.defaults.headers.post['Content-Type'] = 'application/json';
        const response = await axios.post(`${process.env.VUE_APP_BASE_API}/spectral-api/api/user/openwebuserfeedback/save`,
          data,
          {}
        );
        return response.data;
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * 用户注销账户验证码
     * @param {*} data 
     * @returns 
     */
    sendClearAccountCode: async (data) => {
      try {
        axios.defaults.headers.post['Content-Type'] = 'application/json';
        const response = await axios.post(`${process.env.VUE_APP_BASE_API}/spectral-api/api/sendClearAccountCode`,
          data,
          {
            headers: {
              token: sessionStorage.getItem('token')
            }
          }
        );
        return response.data;
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * 注销用户
     * @param {*} data 
     * @returns 
     */
    clearAccount: async (data) => {
      try {
        axios.defaults.headers.post['Content-Type'] = 'application/json';
        const response = await axios.post(`${process.env.VUE_APP_BASE_API}/spectral-api/api/clearAccount`,
          data,
          {
            headers: {
              token: sessionStorage.getItem('token')
            }
          }
        );
        return response.data;
      } catch (error) {
        console.log(error)
      }
    },
};